export default "__VITE_ASSET__004df235__"